// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"415":"e79dc579","606":"a94b8af7","968":"3837fb9d"}[chunkId] + ".js";
};